export function toNumOrNull(s: string): number | null {
  const t = s.trim();
  if (t === '') return null;
  const n = Number(t.replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

export function toIntOrNull(s: string): number | null {
  const n = toNumOrNull(s);
  return n === null ? null : Math.round(n);
}
